// Copyright (c) 2022 by Move Closer

import { ComponentInternalInstance, ref } from '@vue/composition-api'

import { ComponentObjectPropsOptions } from '../../vue-api'
import { userClassRegistry } from '../../composables/use-class-registry'

import { CardDirection, CardProps, UseCardContentProvides } from './Card.contracts'
import { variantsDirectionRegistry } from './Card.config'

/**
 * @author Filip Rurak <filip.rurak@movecloser.pl>
 */
export const cardProps: ComponentObjectPropsOptions<CardProps> = {
  /**
   * define whether Card should have flex direction column or row
   * @see variantsDirectionRegistry
   */
  direction: {
    type: String,
    required: false
  }
}

/**
 * @author Filip Rurak <filip.rurak@movecloser.pl>
 */
export const useCard = (props: CardProps, internalInstance: ComponentInternalInstance | null): UseCardContentProvides => {
  if (internalInstance === null) {
    throw new Error('useCard(): FATAL ERROR! Failed to resolve the component instance!')
  }

  /**
   * card flex direction
   * @see variantsDirectionRegistry
   */
  const direction = ref(props.direction)

  const { type } = internalInstance

  /**
   * resolve direction from registry
   */
  const cardDirectionClass = userClassRegistry(direction, variantsDirectionRegistry, `${type._componentTag}`, '', true, CardDirection.Default)

  return { cardDirectionClass }
}
